<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Redigera försening
      </v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col>
            <v-text-field
              label="Tågnummer"
              outlined
              type="number"
              v-model.number="model.train_number"
              :rules="[required]"
            />
          </v-col>
          <RejectedStopTypeField />
        </v-row>

        <RejectedStopLocationFields />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="updatePending">
          Redigera försening
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import RejectedStopTypeField from './RejectedStopForm/RejectedStopTypeField'
import RejectedStopLocationFields from './RejectedStopForm/RejectedStopLocationFields'

export default {
  name: 'RejectedStopEditModal',

  components: {
    RejectedStopTypeField,
    RejectedStopLocationFields
  },

  props: {
    item: Object
  },

  data: () => ({
    required,
    valid: true,
    updatePending: false
  }),

  created() {
    const updateModel = Object.keys(this.model).reduce((acc, key) => {
      if (key === 'uuid') {
        acc[key] = this.model[key]
      } else {
        acc[key] = this.item[key]
      }
      return acc
    }, {})

    this.$store.set('rejectedStop/model', {
      ...updateModel
    })

    if (updateModel.places) {
      this.$store.set(
        'rejectedStop/model@places',
        updateModel.places.split(', ')
      )
    }
  },

  computed: {
    model: sync('rejectedStop/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.updatePending = true

      const payload = {
        ...this.model,
        places: this.model.places.join(', '),
        from: this.model.places[0],
        to: this.model.places[0],
        checked: true
      }

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceTrainDeviationInput!) {
            replaceTrainDeviation(payload: $payload) {
              train_deviation_uuid
            }
          }
        `,
        variables: {
          payload: {
            delete_uuid: this.item.uuid,
            payload
          }
        }
      })
      this.$store.set(`trainDeviation/data@${this.item.uuid}.deleted`, true)
      this.$store.set(`trainDeviation/data@${payload.uuid}`, payload)

      this.updatePending = false
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('rejectedStop/resetModel')
      this.$emit('close-modal')
    }
  }
}
</script>
